import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Grid } from '@material-ui/core';

import {
    ViewTemplateIcon,
    ReplaceTemplateIcon,
    EditTemplateIcon,
} from '@dev/ee-components';

import { getApiPath } from '@/services/Secuirty';
import { ShowDialogParams } from '@/store/dialog/types';
import { ShowDialog } from '@/store/dialog/actions';
import { SetIsTemplateOpen, SetTemplatePreview, TemplateDeselect, getLandingPageCreatorStore } from '@/store/landingPageCreator/actions';

import { TemplatePreviewButton } from '@/assets/TemplatePreviewButton';
import { ScreenshotWrapper, ScreenshotHover } from './styles';

type Step2ContentProps = {
    isEditMode: boolean;
}

export const Step2Content = ({isEditMode}:Step2ContentProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { templateObject } = useSelector(getLandingPageCreatorStore);
    const templateScreenshot = templateObject?.Screenshot ?? templateObject?.MediumScreenshot;

    const editTemplate = (): void => {
        dispatch(SetIsTemplateOpen(true));
    };

    const viewTemplate = (): void => {
        dispatch(SetTemplatePreview(templateObject?.Body?.Parts?.find((part) => part.ContentType === 'text/html')?.Content));
    };
    
    const deselectTemplate = (): void => {
        dispatch(TemplateDeselect());
    };

    const replaceTemplate = (): void => {
        const dialogParams: ShowDialogParams = {
            title: t('replacetemplate'),
            confirmLabel: t('confirm'),
            body: t('replacetemplatedescription'),
            onClickConfirm: deselectTemplate,
            cancelLabel: t('cancel'),
        };
        dispatch(ShowDialog(dialogParams));
    };

    return (
        <ScreenshotWrapper>
            <ScreenshotHover>
                <Grid item style={{ justifySelf: 'flex-end', marginTop: 24, marginRight: 24 }}>
                    {isEditMode && (
                        <TemplatePreviewButton
                            id={"landingpage-replace-template"}
                            buttonIcon={<ReplaceTemplateIcon width={28.8} height={28.8} />}
                            buttonLabel={t('replace')}
                            handleOnClick={replaceTemplate}
                        />
                    )}
                </Grid>
                <Grid
                    container
                    style={{ marginTop: 24, marginBottom: 24, gap: 16 }}
                    direction="row"
                    justifyContent="center"
                >
                    <TemplatePreviewButton
                        id={"landingpage-view-template"}
                        buttonIcon={<ViewTemplateIcon width={28.8} height={28.8} />}
                        buttonLabel={t('view')}
                        handleOnClick={viewTemplate}
                    />
                    {isEditMode && (
                        <TemplatePreviewButton
                            id={"landingpage-edit-template"}
                            buttonIcon={<EditTemplateIcon width={31.5} height={31.5} />}
                            buttonLabel={t('edit')}
                            handleOnClick={editTemplate}
                        />
                    )}
                </Grid>
            </ScreenshotHover>
            <img src={`${getApiPath()}/userfile${encodeURI(templateScreenshot)}`} />
        </ScreenshotWrapper>
    );
}

